module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-658152c2a4df599618359b94a544e2ee.jpg";